export const visaBulletin = {
  month: "April 2026",
  finalActionDates: {
    eb1: {
      restOfWorld: "Current",
      china: "Apr 1, 2023",
      india: "Dec 1, 2023",
      mexico: "Current",
      philippines: "Current",
    },
    eb2: {
      restOfWorld: "Current",
      china: "Sep 1, 2021",
      india: "Jul 15, 2014",
      mexico: "Current",
      philippines: "Current",
    },
    eb3: {
      restOfWorld: "Current",
      china: "Jun 15, 2021",
      india: "Nov 15, 2013",
      mexico: "Current",
      philippines: "Current",
    },
  },
  datesForFiling: {
    eb1: {
      restOfWorld: "Current",
      china: "Dec 1, 2023",
      india: "Dec 1, 2023",
      mexico: "Current",
      philippines: "Current",
    },
    eb2: {
      restOfWorld: "Current",
      china: "Jan 1, 2022",
      india: "Jan 15, 2015",
      mexico: "Current",
      philippines: "Current",
    },
    eb3: {
      restOfWorld: "Current",
      china: "Jan 1, 2022",
      india: "Jan 15, 2015",
      mexico: "Current",
      philippines: "Current",
    },
  },
};

export const estimatedWaitTimes = {
  india: {
    eb1: "2-3 years",
    eb2: "12+ years",
    eb3: "12+ years",
  },
  china: {
    eb1: "3-4 years",
    eb2: "5-8 years",
    eb3: "5-8 years",
  },
  row: {
    eb1: "Current",
    eb2: "Current",
    eb3: "Current",
  },
};

export const historicalEB2India = [
  { date: "Oct 2021", fad: "Sep 1, 2011", backlog: "~10 years" },
  { date: "Apr 2022", fad: "Jan 1, 2012", backlog: "~10 years" },
  { date: "Oct 2022", fad: "Apr 1, 2012", backlog: "~10.5 years" },
  { date: "Apr 2023", fad: "Jun 1, 2012", backlog: "~11 years" },
  { date: "Oct 2023", fad: "Sep 1, 2012", backlog: "~11 years" },
  { date: "Apr 2024", fad: "Jan 15, 2013", backlog: "~11 years" },
  { date: "Oct 2024", fad: "Jun 1, 2013", backlog: "~11.5 years" },
  { date: "Jan 2025", fad: "Sep 1, 2013", backlog: "~11.5 years" },
  { date: "Apr 2025", fad: "Jan 1, 2014", backlog: "~11 years" },
  { date: "Oct 2025", fad: "Apr 1, 2014", backlog: "~11.5 years" },
  { date: "Jan 2026", fad: "Jun 1, 2014", backlog: "~11.5 years" },
  { date: "Apr 2026", fad: "Jul 15, 2014", backlog: "~12 years" },
];

export const historicalEB2China = [
  { date: "Oct 2021", fad: "Jun 1, 2018", backlog: "~3.5 years" },
  { date: "Apr 2022", fad: "Oct 1, 2018", backlog: "~3.5 years" },
  { date: "Oct 2022", fad: "Apr 1, 2019", backlog: "~3.5 years" },
  { date: "Apr 2023", fad: "Sep 1, 2019", backlog: "~3.5 years" },
  { date: "Oct 2023", fad: "Mar 1, 2020", backlog: "~3.5 years" },
  { date: "Apr 2024", fad: "Sep 1, 2020", backlog: "~3.5 years" },
  { date: "Oct 2024", fad: "Mar 1, 2021", backlog: "~3.5 years" },
  { date: "Jan 2025", fad: "Jun 1, 2021", backlog: "~4 years" },
  { date: "Apr 2025", fad: "Jul 1, 2021", backlog: "~4 years" },
  { date: "Oct 2025", fad: "Aug 1, 2021", backlog: "~4 years" },
  { date: "Jan 2026", fad: "Aug 15, 2021", backlog: "~4.5 years" },
  { date: "Apr 2026", fad: "Sep 1, 2021", backlog: "~5 years" },
];
